function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from "prop-types";
export default function Div(props) {
  var _props$classNames, _props$classNames$joi;
  var style = {};
  var u = function u(v) {
    return typeof v === "string" ? v : "".concat(v).concat(props.units);
  };
  if (props.w) {
    style.width = u(props.w);
  }
  if (props.h) {
    style.height = u(props.h);
  }
  if (props.pad) {
    style.padding = u(props.pad);
  }
  if (props.padL) {
    style.paddingLeft = u(props.padL);
  }
  if (props.padR) {
    style.paddingRight = u(props.padR);
  }
  if (props.padB) {
    style.paddingBottom = u(props.padB);
  }
  if (props.padT) {
    style.paddingTop = u(props.padT);
  }
  if (props.style) {
    style = _objectSpread(_objectSpread({}, style), props.style);
  }
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: (_props$classNames = props.classNames) === null || _props$classNames === void 0 || (_props$classNames$joi = _props$classNames.join) === null || _props$classNames$joi === void 0 ? void 0 : _props$classNames$joi.call(_props$classNames, ' ')
  }, props.children);
}
Div.propTypes = {
  w: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  h: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  units: PropTypes.string,
  pad: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padL: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padR: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  classNames: PropTypes.arrayOf(PropTypes.string)
};
Div.defaultProps = {
  units: "px"
};